import { stringOrUndefined } from '@helpers/strings'

export type OpprefTrackingParams = {
  oppref?: string
}

// Partners are inconsistent about casing, mirroring what we already saw with `clickId`/`clickid`.
export const OPPREF_URL_PARAM_NAMES = ['oppref', 'oppRef', 'OPPREF'] as const

export const readOpprefFromSearchParams = (searchParams: URLSearchParams): string | undefined =>
  OPPREF_URL_PARAM_NAMES.reduce<string | undefined>(
    (found, name) => found ?? stringOrUndefined(searchParams.get(name)),
    undefined
  )

export const buildOpprefTrackingParams = (value: unknown): OpprefTrackingParams => {
  const oppref = stringOrUndefined(value)

  return oppref ? { oppref } : {}
}
